module.exports = __webpack_public_path__ + "static/logo.eed43354.png";